import { useState } from "react";
import { Outlet } from "react-router-dom";

export const SolicitudesLayout = () => {
    const [ciudad, setCiudad] = useState(null);
    const [sede, setSede] = useState(null);
    const [area, setArea] = useState(null);
    const [tipoSolicitud, setTipoSolicitud] = useState(null);

    return (
        <Outlet
            context={{
                ciudad,
                setCiudad,
                sede,
                setSede,
                area,
                setArea,
                tipoSolicitud,
                setTipoSolicitud,
            }}
        />
    );
};
